import {
  Badge,
  Box,
  Button,
  Flex,
  Group,
  Loader,
  Modal,
  Paper,
  Table,
  Text,
  TextInput,
  Textarea,
  Title,
  createStyles,
} from "@mantine/core";
import { useMedplum } from "@medplum/react";
import { IconChecklist, IconTargetArrow } from "@tabler/icons-react";
import { useEffect, useState } from "react";

import { useNavigate, useParams } from "react-router-dom";
import { fetchGoalsAndTasks, fetchResource } from "./CareplanService";
import ResourceDisplay from "../../CarePlan/ResourceView";
import { showNotification } from "@mantine/notifications";

const useStyles = createStyles((theme) => ({
  medicalDocPaper: {
    marginTop: "20px",
    borderRadius: "8px",
    marginLeft: "0px",
    marginRight: "0px",
    padding: "20px",
    background: "'#FFF",
    boxShadow: "0px 1px 24px 2px rgba(0, 0, 0, 0.06)",
  },
  table: {
    marginTop: "30px",
  },
  thead: {
    backgroundColor: "#BEDEF8",
    borderRadius: 4,
  },
}));

interface ReportProps {
  patient?: any;
  PatientDetails?: any;
}

export const CarePlan = ({ patient, PatientDetails }: ReportProps) => {
  const { patientId } = useParams();

  useEffect(() => {
    fetchCarePlan();
  }, []);
  const navigate = useNavigate();
  const { classes } = useStyles();
  const medplum = useMedplum();
  const [carePlans, setcarePlans] = useState<any>([]);
  const [createCarePlan, setCreateCarePlan] = useState<boolean>(false);
  const [formData, setFormData] = useState({ title: "", description: "" });
  const [errors, setErrors] = useState({ title: false, description: false });
  const [resourceData,setResourceData]=useState<any>([])
  const [resourceType,setResourceType]=useState<any>()
  const [taskLoading,setTaskloading]=useState<any>(false)
  const [goalLoading,setgoalLoading]=useState<any>(false)
  const [loading,setLoading]=useState<any>(false)

  const [taskLoadingId, setTaskLoadingId] = useState<string | null>(null);
  const [goalLoadingId, setGoalLoadingId] = useState<string | null>(null);
  // const [goals,setGoals]=useState<any>()
  const [isModalOpen, setIsModalOpen] = useState(false);


  const fetchCarePlan = async () => {
    setLoading(true)
    const query = `_count=20&_offset=0&_sort=-_lastUpdated&_total=accurate&patient=Patient/${patientId}`;

    const response = await medplum.searchResources("CarePlan", query);
    setcarePlans(response);
    setLoading(false)
  };
  const handleShowTasks = async (activities: any, planId: string) => {
    setTaskLoadingId(planId); // Set the ID of the plan whose button is loading
    const taskIds = activities
      ?.map((activity: any) => {
        const reference = activity?.reference?.reference;
        return reference ? reference?.split('/').pop() : null;
      })
      .filter((id: any) => id !== null);
  
    if (!taskIds || taskIds.length === 0) {
      showNotification({ color: 'red', message: "No tasks Found!", autoClose: true });
      setTaskLoadingId(null);
    } else {
      const fetchAllTasks = await fetchResource('Task', medplum, taskIds);
      setTaskLoadingId(null);
      setIsModalOpen(true);
      setResourceType("Task");
      setResourceData(fetchAllTasks);
    }
  };
  


  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    if (value.trim() !== "") {
      setErrors({ ...errors, [name]: false });
    }
  };
  const handleSubmit = async (e: any) => {
    e.preventDefault();
    const { title, description } = formData;

    if (title.trim() === "" || description.trim() === "") {
      setErrors({
        title: title.trim() === "",
        description: description.trim() === "",
      });
      return;
    }

  };

  const handleShowGoals = async (goals: any, planId: string) => {
    setGoalLoadingId(planId); // Set the ID of the plan whose button is loading
    const goalIds = goals
      ?.map((goal: any) => {
        const reference = goal?.reference;
        return reference ? reference?.split('/').pop() : null;
      })
      .filter((id: any) => id !== null);
  
    if (!goalIds || goalIds.length === 0) {
      setGoalLoadingId(null);
      showNotification({ color: 'red', message: "No Goals Found!", autoClose: true });
    } else {
      const fetchAllGoals = await fetchResource('Goal', medplum, goalIds);
      setGoalLoadingId(null);
      setIsModalOpen(true);
      setResourceType("Goal");
      setResourceData(fetchAllGoals);
    }
  };

  return (
    <>
      <Paper className={classes.medicalDocPaper} withBorder>
        <Flex justify={"space-between"}>
          <Title>Care Plan</Title>
          <Button
            onClick={() => {
              navigate("/admin/care-plan", {
                state: { patientId, PatientDetails },
              });
            }}
          >
            New Care Plan
          </Button>
        </Flex>
        {loading?<Box sx={{display:"flex",justifyContent:"center"}}><Loader/></Box>:<>  <Table className={classes.table}>
          <thead className={classes.thead}>
            <tr>
              <th>Title</th>
              <th>Status</th>
              {/* <th>Intent</th> */}
              <th>Last Updated</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {carePlans.map((plan: any) => (
              <tr key={plan?.id}>
                <td>{plan?.title}</td>
                <td>
                  <Badge color="green">{plan?.status}</Badge>
                  </td>
                {/* <td>{plan?.intent}</td> */}
                <td>{new Date(plan?.meta?.lastUpdated).toLocaleString()}</td>
                <td>
                  <Button
          onClick={() => handleShowTasks(plan?.activity, plan?.id)}
          size="xs"
                    miw={'90px'}

                    // color="blue"
                    variant="outline"
                  >
                    {taskLoadingId === plan.id ? (
            <Loader color="blue" size="sm" />
          ) : (
            <>
              <IconChecklist size={14} color="#318CE7" />
              <Text ml="sm">Tasks</Text>
            </>
          )}
                 
                  </Button>
                  <Button
                  miw={'90px'}
                  onClick={() => handleShowGoals(plan?.goal, plan?.id)}
                  size="xs"
                    ml="xs"
                  >
                    {goalLoadingId === plan.id ? (
            <Loader size="sm" color="white" />
          ) : (
            <>
              <IconTargetArrow size={14} color="white" />
              <Text ml="sm">Goals</Text>
            </>
          )}
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table></>}
      
        <Modal
        withCloseButton={false}
      centered
        opened={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        // title={`All ${resourceType} for associated care plan`}
        size="lg"
      >
        <Text fw={700} size="lg">Care Plan {resourceType}'s</Text>

<Box
        sx={{
          maxHeight: '400px',
          overflowY: 'auto',
          // border: '1px solid #ddd',
          padding: '1rem',
          '&::-webkit-scrollbar': {
            width: '2px',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'black',
          },
          '&:hover::-webkit-scrollbar': {
            width: '2px',
          },
        }}
      >
        <ResourceDisplay resourceType={resourceType} resourceData={resourceData} />
      </Box>        
      </Modal>
        
      </Paper>
    </>
  );
};
